import { render } from "./lockedContent.vue?vue&type=template&id=17c00b48&scoped=true&ts=true"
import script from "./lockedContent.vue?vue&type=script&lang=ts"
export * from "./lockedContent.vue?vue&type=script&lang=ts"

import "./lockedContent.vue?vue&type=style&index=0&id=17c00b48&scoped=true&lang=scss"
import "./lockedContent.vue?vue&type=style&index=1&id=17c00b48&lang=scss"

import exportComponent from "/builds/web-primary/web-novel-stores/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17c00b48"]])

export default __exports__